import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { get } from 'lodash';

import Shot, { ShotsList, ShotsListItem } from './../../exercise/barrage/shot';
import MathContent from '../../math-content';

const ShotAndFeedbackContainer = styled.div`
    vertical-align: top;

    margin-left: 16px;
    margin-bottom: 32px;

    font-weight: normal;
`;

const Container = styled.div`
    display: flex;
`;

const Label = styled.strong`
    display: inline-block;

    margin-right: 4px;
    margin-top: 8px;
`;

export const Feedback = styled(MathContent)`
    display: inline-block;

    margin-top: 8px;

    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
`;

const Header = styled.div`
    margin: 0 36px;
`;

const getLabel = (validation) => {
    if (validation === 'missing') {
        return 'Risposta non data.';
    }

    return validation === 'success' ? 'Risposta esatta.' : 'Risposta sbagliata.';
};
export const handleValidation = (shot, answers) => {
    let match = get(
        answers.find((item) => item.shotId === shot.id),
        'answerId',
    );
    return match === undefined ? 'missing' : match === shot.idRef ? 'success' : 'error';
};
const BarrageCorrection = ({ exercise, answers, correctionStatus, solution }) => {
    const selectedAnswers = answers ? answers.answer : [];

    return (
        <div>
            <Header>
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                {exercise.question && <MathContent>{exercise.question}</MathContent>}
            </Header>

            <ShotsList>
                {exercise.shots.map((shot, index) => (
                    <Container key={index}>
                        <ShotsListItem />

                        <ShotAndFeedbackContainer>
                            <Shot
                                answers={exercise.options}
                                badgeIndex={index + 1}
                                correctAnswerId={shot.idRef}
                                id={shot.id}
                                isValidated={solution || !!correctionStatus}
                                selectedAnswerId={get(
                                    selectedAnswers.find((item) => item.shotId === shot.id),
                                    'answerId',
                                )}
                                text={shot.text}
                                validationType={handleValidation(shot, selectedAnswers, solution)}
                            />
                            <div>
                                {solution ? (
                                    shot.feedback && <Label>{'Feedback specifico.'}</Label>
                                ) : (
                                    <Label>{getLabel(handleValidation(shot, selectedAnswers))}</Label>
                                )}

                                {shot.feedback && <Feedback>{shot.feedback}</Feedback>}
                            </div>
                        </ShotAndFeedbackContainer>
                    </Container>
                ))}
            </ShotsList>
        </div>
    );
};

BarrageCorrection.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
    solution: PropTypes.bool,
};

export default BarrageCorrection;
